<!--
/**
* @name: List.vue
* @description: 版本控制
* @author: 于海威
* @create: 2020/08/07 17:56:27
* @update: 2020/08/07 17:56:27
*/
-->

<template>
  <y-view :loading="isLoading">
    <y-query spaceBetween @search="onSearch">
      <y-query-item>
        <k-input placeholder="请输入版本号" v-model="para.version" clearable></k-input>
      </y-query-item>
      <y-query-item slot="right">
        <y-button icon="k-icon-add" @click="onAddVersion">上传</y-button>
      </y-query-item>
    </y-query>
    <k-table :data="versionList" :height="$root.tableHeightX" :rightFixedNumber="1" :columns="initColumns()"></k-table>
    <k-pagination :total="total" v-if="versionList && versionList.length" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
  </y-view>
</template>

<script>
import { NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_DELETE, NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_PAGE } from "@/assets/modules/apiList";

const initPara = () => ({
  pageCurrent: 1,
  pageSize: 15,
  version: "",
});
export default {
  data() {
    return {
      versionList: [],
      para: initPara(),
      total: 0,
      isLoading: false,
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "APP名称",
          field: "name",
          style: {
            width: 80,
          },
        },
        {
          name: "版本号",
          field: "version",
          style: {
            width: 100,
          },
        },
        {
          name: "销售渠道",
          field: "saleChannelCodeName",
          style: {
            width: 80,
          },
        },
        {
          name: "升级描述",
          field: "description",
          style: {
            width: 120,
          },
        },
        {
          name: "下载地址",
          field: "url",
          style: {
            width: 80,
          },
        },
        {
          name: "Android/IOS",
          field: "os",
          style: {
            width: 80,
          },
        },
        {
          name: "是否强制更新",
          field: "",
          style: {
            width: 80,
          },
          customRender: (row) => <span>{row.isForceUpdate ? "是" : "否"}</span>,
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 80,
          },
          customRender: (row) => {
            // const viewButton = <a href="javascript:void(0);" onClick={() => { this.onView(row); }}>查看</a>;
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                修改
              </a>
            );
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                删除
              </a>
            );
            return (
              <div>
                {editButton}&#12288;{deleteButton}
              </div>
            );
          },
        },
      ];
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getVersionList();
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getVersionList();
    },
    onAddVersion() {
      this.$controller.open({
        name: "versionAdd",
        query: {
          refresh: new Date() - 0,
        },
      });
    },
    onEdit(row) {
      const { id } = row;
      this.$controller.open({
        name: "versionAdd",
        query: {
          refresh: new Date() - 0,
          id,
          edit: 1,
        },
        title: "编辑APP版本",
      });
    },
    onDelete(row) {
      const { id } = row;
      this.$dialog({
        title: "提示",
        content: "是否确认删除该版本？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_DELETE,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getVersionList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getVersionList() {
      this.isLoading = true;
      let { para } = this;
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_APP_VERSION_PAGE,
        para,
      })
        .then((res) => {
          this.isLoading = false;
          this.versionList = res.pageList;
          this.total = res.total;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  created() {
    this.getVersionList();
  },
  beforeRouteUpdate(to, from, next) {
    this.getVersionList();
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
